const actionTypes = {
    ERROR: 'ERROR',
    CHECK: 'CHECK',
    CONFIRM: 'CONFIRM',
    CHANGE: 'CHANGE',
    DELETE: 'DELETE',
    RESET: 'RESET'
};

export default actionTypes;